/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS python filter api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    CircleGeometry,
    instanceOfCircleGeometry,
    CircleGeometryFromJSON,
    CircleGeometryFromJSONTyped,
    CircleGeometryToJSON,
} from './CircleGeometry';
import {
    LineStringGeometry,
    instanceOfLineStringGeometry,
    LineStringGeometryFromJSON,
    LineStringGeometryFromJSONTyped,
    LineStringGeometryToJSON,
} from './LineStringGeometry';
import {
    PointGeometry,
    instanceOfPointGeometry,
    PointGeometryFromJSON,
    PointGeometryFromJSONTyped,
    PointGeometryToJSON,
} from './PointGeometry';
import {
    PolygonGeometry,
    instanceOfPolygonGeometry,
    PolygonGeometryFromJSON,
    PolygonGeometryFromJSONTyped,
    PolygonGeometryToJSON,
} from './PolygonGeometry';

/**
 * @type Geometry
 * 
 * @export
 */
export type Geometry = CircleGeometry | LineStringGeometry | PointGeometry | PolygonGeometry;

export function GeometryFromJSON(json: any): Geometry {
    return GeometryFromJSONTyped(json, false);
}

export function GeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Geometry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...CircleGeometryFromJSONTyped(json, true), ...LineStringGeometryFromJSONTyped(json, true), ...PointGeometryFromJSONTyped(json, true), ...PolygonGeometryFromJSONTyped(json, true) };
}

export function GeometryToJSON(value?: Geometry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCircleGeometry(value)) {
        return CircleGeometryToJSON(value as CircleGeometry);
    }
    if (instanceOfLineStringGeometry(value)) {
        return LineStringGeometryToJSON(value as LineStringGeometry);
    }
    if (instanceOfPointGeometry(value)) {
        return PointGeometryToJSON(value as PointGeometry);
    }
    if (instanceOfPolygonGeometry(value)) {
        return PolygonGeometryToJSON(value as PolygonGeometry);
    }

    return {};
}

